import React from "react";

import * as S from "./styles";

export const BannerInterest: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Title>
          <span>Seja um</span> franqueado
        </S.Title>
      </S.Wrapper>
    </S.Container>
  );
};
